import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../../theme";
import { InputDropdown } from "../../../../theme/dropdowns/InputDropdown";
import Text from "../../../../theme/text/Text";



export const RhPivotTableColumn = (props) => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // A report that owns its column dimension has nothing to pick: the column is what the report is.
    // Show it as a label rather than a dropdown, so there is no option to choose the wrong thing.
    const fixedColumn = props.chartOption?.fixedPivotColumn;
    if (fixedColumn) {
        return (
            <Box
                sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    height: 24,
                    px: 1.5,
                    borderRadius: 4,
                    background: theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[100],
                }}
            >
                <Text bold noBreak>{t(fixedColumn)}</Text>
            </Box>
        );
    }

    return (
        <InputDropdown
            key={props.currentReport.table.row + " " + props.currentReport.table.column.key}
            onChange={(selected) => {
                if(selected === null || selected === -1) return;
                const selectedOption = props.chartOption?.pivotTableOptions.filter(item => item !== props.currentReport.table.row)[selected];
                props.setCurrentReport(prev => ({
                    ...prev,
                    table: {
                        ...prev.table,
                        column: {
                            ...prev.table.column,
                            key:selectedOption,
                            values:[],
                        },
                    }
                }))
            }}
            noSelection={t("select_column")} //Custom text when nothing is selected
            options={props.chartOption?.pivotTableOptions.filter(item => item !== props.currentReport.table.row) ?? null}
            selected={props.chartOption?.pivotTableOptions?.filter(item => item !== props.currentReport.table.row).findIndex(filter => filter === props.currentReport.table.column.key) ?? -1}
            closeOnSelection
            stopPropagation
            disallowDeselection
            useTranslation
            height={24}
        />
    )
}